import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
// Import action untuk menutup modal (Anda perlu membuatnya di store)
// import { hideStatusModal } from "../../store/actions"; 

const GlobalStatusModal = () => {
  const dispatch = useDispatch();
  
  // Asumsi state disimpan di state.Layout atau state.Common
  const { isOpen, type, title, message } = useSelector(state => state.Layout.statusModal || {
    isOpen: false,
    type: "success",
    title: "",
    message: ""
  });

  const toggle = () => {
    // dispatch(hideStatusModal());
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="text-center p-5">
        <div className="mb-4">
          {type === "success" ? (
            <i className="mdi mdi-check-circle-outline text-success" style={{ fontSize: "60px" }}></i>
          ) : (
            <i className="mdi mdi-alert-circle-outline text-danger" style={{ fontSize: "60px" }}></i>
          )}
        </div>
        <h4 className="mb-3">{title}</h4>
        <p className="text-muted mb-4">{message}</p>
        <Button 
          color={type === "success" ? "success" : "danger"} 
          onClick={toggle}
          className="px-5"
        >
          OK
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default GlobalStatusModal;